import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    if (form.password.length < 6) { setErr("Password must be at least 6 characters"); setLoading(false); return; }
    try {
      await register(form.email, form.password, form.name);
      nav("/account");
    } catch (e) {
      setErr(e.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">
      <form onSubmit={submit} className="p-8 md:p-12 flex flex-col justify-center order-2 md:order-1">
        <div className="tag mb-4">Register</div>
        <h2 className="text-3xl font-black tracking-tighter uppercase font-[Outfit]">Create Account</h2>
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest font-bold font-[Outfit] block mb-2">Full Name</label>
            <input data-testid="register-name" required className="input-brutal" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold font-[Outfit] block mb-2">Email</label>
            <input data-testid="register-email" type="email" required className="input-brutal" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest font-bold font-[Outfit] block mb-2">Password</label>
            <input data-testid="register-password" type="password" required minLength={6} className="input-brutal" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>
          {err && <div data-testid="register-error" className="border border-[#ff3333] bg-[#fff3f3] px-3 py-2 text-sm text-[#cc0000] font-bold uppercase tracking-wider font-[Outfit]">{err}</div>}
          <button data-testid="register-submit" disabled={loading} className="btn-brutal btn-red w-full">{loading ? "..." : "Create Account →"}</button>
          <div className="text-sm text-zinc-600">Have an account? <Link to="/login" className="underline font-bold">Log in</Link></div>
        </div>
      </form>
      <div className="hidden md:flex flex-col justify-between p-12 border-l border-zinc-900 bg-[#ff3333] text-white order-1 md:order-2 relative noise">
        <div>
          <div className="text-xs uppercase tracking-widest font-[Outfit] font-bold">Stuffly</div>
          <h1 className="text-5xl font-black tracking-tighter uppercase mt-4 font-[Outfit] leading-[0.9]">Join The<br />Catalogue.</h1>
        </div>
        <p className="text-sm">Save time at checkout, view orders, and unlock member-only flash drops.</p>
      </div>
    </div>
  );
}
